<!-- Header -->
<div mat-dialog-title class="flex justify-between items-center">
  <div class="w-full flex justify-between items-center">
    <span class="text-lg font-medium">Mise à jour du statut</span>
  </div>
</div>

<!-- Dialog Content -->
<mat-dialog-content class="flex flex-col items-center justify-center text-center py-6">
  <div class="flex flex-col items-center justify-center space-y-4">
    <!-- Saving State -->
    <ng-container *ngIf="!isSaved">
      <mat-spinner diameter="50" color="primary"></mat-spinner>
      <p>Enregistrement de vos données...</p>
    </ng-container>

    <!-- Extracting State -->
    <ng-container *ngIf="isSaved && !isExtracted">
      <div class="flex flex-col items-center justify-center space-y-4">
        <mat-spinner diameter="50" color="accent"></mat-spinner>
        <p>Extraction en cours. Cela peut prendre quelques minutes.</p>
      </div>
    </ng-container>

    <!-- Done State -->
    <ng-container *ngIf="isExtracted">
      <div class="flex flex-col items-center justify-center space-y-4">
        <mat-icon color="accent" style="font-size: 40px;">assignment_turned_in</mat-icon>
        <p>Extraction terminée!</p>
      </div>
    </ng-container>
  </div>
</mat-dialog-content>

<!-- Dialog Actions -->
<mat-dialog-actions class="flex justify-end mt-4 space-x-2">
  <button mat-stroked-button color="warn" *ngIf="isSaved && !isExtracted" (click)="redirectWithoutWaiting()">
    Continuer sans attendre
  </button>

  <button mat-flat-button color="accent" *ngIf="isExtracted" (click)="redirectAfterExtractionDone()">
    Continuer vers les détails du projet
  </button>
</mat-dialog-actions>
